import { CompatibilityCheckerApi } from 'ctp-compatibility-checker';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const accessConfig = {
  apiKey: () => userManager.getApiKey(), // without this --> 401
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

// eslint-disable-next-line import/prefer-default-export -- TODO
export const compatibilityCheckerApiCaller = new CompatibilityCheckerApi(accessConfig, routes.apiRoutes.basePath);
